export default axios => ({
    login(payload) {
        return axios.post(`/login`, payload)
    },
    email(payload) {
        return axios.post(`/password/email`, payload)
    },
    reset(payload) {
        return axios.post(`/password/reset`, payload)
    },
})
